/* Novatio Add-ons v1.5 — proxy Add to cart button (immune to Shiprocket smart cart hijacking) */
(() => {
  if (window.__nvAddons) return;
  window.__nvAddons = true;

  /* ===== SETTINGS — the only part you should ever edit ===== */
  const SETTINGS = {
    proxyButton: true,                   // our own Add to cart appears when add-ons are ticked (needed for Shiprocket smart cart)
    addToCartSelector: 'button[name="add"], form[action*="/cart/add"] [type="submit"], .product-form__submit, [data-add-to-cart], [data-action="add-to-cart"], .add-to-cart, .btn-addtocart, #AddToCart, #add-to-cart',
    buyNowSelector: '.shopify-payment-button, [class*="fastrr"], [id*="fastrr"], [class*="shiprocket"], [class*="sr-headless"], [class*="pickrr"]',
    buyNowMode: 'cart',                  // 'cart' = add all & open cart | 'checkout' = add all & go to checkout | 'hide' = hide Buy Now when add-ons ticked
    itemLabel: 'Saree',
    detailsAttribute: 'Add-on Details',
    summaryLabel: 'Saree',
    sectionRenderFallback: false
  };
  /* ========================================================== */

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const DRAWER_SCOPE = 'cart-drawer, [id*="cart-drawer"], [id*="CartDrawer"]';
  const ITEM_KEY = 'Item';
  const FOR_KEY = 'For';
  const escRe = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const ITEM_RE = new RegExp('^(' + escRe(SETTINGS.itemLabel) + ' \\d+)');
  const nativeFetch = window.fetch.bind(window);
  const liveFetch = (input, init) => window.fetch(input, init);
  const isCartPage = () => /\/cart\/?$/.test(location.pathname);

  // global helper styles
  const helperCss = document.createElement('style');
  helperCss.textContent = '.nv-atc-hidden{display:none!important}.nv-atc[hidden]{display:none!important}.nv-atc{cursor:pointer}.nv-atc[aria-busy="true"]{opacity:.7;pointer-events:none}';
  document.head.appendChild(helperCss);

  function formatMoney(cents, format) {
    const n = (Number(cents) || 0) / 100;
    const map = {
      amount: n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals: Math.round(n).toLocaleString('en-IN'),
      amount_with_comma_separator: n.toFixed(2).replace('.', ','),
      amount_no_decimals_with_comma_separator: Math.round(n).toLocaleString('de-DE')
    };
    return (format || 'Rs. {{amount}}')
      .replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] || map.amount)
      .replace(/[.,]00(?!\d)/, '');
  }

  /* ---------- Cart API ---------- */
  async function cartPost(path, body) {
    const res = await liveFetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Could not update your cart. Please try again.');
    return data;
  }
  const getCart = () => nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  /* ---------- Theme adapter ---------- */
  async function rerenderDrawer() {
    const sec = document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');
    if (!sec) return;
    const id = sec.id.replace('shopify-section-', '');
    try {
      const json = await nativeFetch(`${ROOT}?sections=${encodeURIComponent(id)}`).then(r => r.json());
      const fresh = json[id] && new DOMParser().parseFromString(json[id], 'text/html').getElementById(sec.id);
      if (fresh) sec.innerHTML = fresh.innerHTML;
    } catch (_) { /* silent */ }
  }

  function openCart() {
    const drawer = document.querySelector('cart-drawer, #cart-drawer');
    if (drawer && typeof drawer.show === 'function') return drawer.show();
    const toggle = document.querySelector('[aria-controls*="cart-drawer"], a[href$="/cart"][aria-controls]');
    if (toggle) return toggle.click();
    window.location.href = ROOT + 'cart';
  }

  async function syncTheme({ open = false } = {}) {
    const cart = await getCart();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
    if (SETTINGS.sectionRenderFallback) await rerenderDrawer();
    if (open) openCart();
    return cart;
  }

  /* ---------- Readable order mapping ---------- */
  function nextItemNumber(cart) {
    let max = 0;
    cart.items.forEach(i => {
      const v = (i.properties || {})[ITEM_KEY];
      const m = v && String(v).match(/(\d+)\s*$/);
      if (m) max = Math.max(max, Number(m[1]));
    });
    return max + 1;
  }

  function describe(line) {
    let s = line.product_title;
    if (line.variant_title && line.variant_title !== 'Default Title') s += ` (${line.variant_title})`;
    if (line.quantity > 1) s += ` ×${line.quantity}`;
    return s;
  }

  function buildDetails(cart) {
    return cart.items
      .filter(i => (i.properties || {})[ITEM_KEY])
      .map(p => {
        const item = p.properties[ITEM_KEY];
        const addons = cart.items.filter(i => {
          const f = (i.properties || {})[FOR_KEY];
          return f && String(f).indexOf(item + ' –') === 0;
        });
        if (!addons.length) return null;
        const sku = p.sku ? ` (${p.sku})` : '';
        return `${item}: ${p.product_title}${sku} → ${addons.map(describe).join(', ')}`;
      })
      .filter(Boolean)
      .join(' | ');
  }

  async function removeBundle(itemName) {
    try {
      const cart = await getCart();
      const updates = {};
      cart.items.forEach(i => {
        const p = i.properties || {};
        if (p[ITEM_KEY] === itemName || String(p[FOR_KEY] || '').indexOf(itemName + ' –') === 0) updates[i.key] = 0;
      });
      if (Object.keys(updates).length) await cartPost('cart/update.js', { updates });
    } catch (_) { /* silent */ }
  }

  /* ---------- Add saree + ALL add-ons in ONE request ---------- */
  async function addBundle(comp, form) {
    const fd = new FormData(form);
    const variantId = Number(fd.get('id'));
    const qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);

    const props = {};
    fd.forEach((v, k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') props[m[1]] = v;
    });

    const itemName = `${SETTINGS.itemLabel} ${nextItemNumber(await getCart())}`;
    props[ITEM_KEY] = itemName;

    const parentLine = { id: variantId, quantity: qty, properties: props };
    const forText = `${itemName} – ${comp.forLabel(String(variantId))}`;
    const children = comp.selected().map(a => {
      const p = { [FOR_KEY]: forText };
      if (a.mode === 'free') p._nv_free = '1';
      return { id: a.variantId, quantity: a.mode === 'free' ? a.qty : qty, properties: p };
    });

    try {
      await cartPost('cart/add.js', {
        items: [parentLine].concat(children.map(c => Object.assign({ parent_id: variantId }, c)))
      });
    } catch (nestErr) {
      await removeBundle(itemName);
      try {
        await cartPost('cart/add.js', { items: [parentLine].concat(children) });
      } catch (err) {
        await removeBundle(itemName);
        throw err;
      }
    }
  }

  /* ---------- Keep cart clean: sync qty, drop orphans, refresh Add-on Details ---------- */
  let syncTimer, running = false, again = false;
  const scheduleReconcile = () => { clearTimeout(syncTimer); syncTimer = setTimeout(reconcile, 350); };

  async function reconcile() {
    if (running) { again = true; return; }
    running = true;
    try {
      let cart = await getCart();
      const parents = {};
      cart.items.forEach(i => {
        const v = (i.properties || {})[ITEM_KEY];
        if (v) parents[v] = i;
      });

      const updates = {};
      cart.items.forEach(i => {
        const p = i.properties || {};
        const f = p[FOR_KEY];
        if (!f) return;
        const m = String(f).match(ITEM_RE);
        const parent = m && parents[m[1]];
        if (!parent) updates[i.key] = 0;
        else if (!p._nv_free && i.quantity !== parent.quantity) updates[i.key] = parent.quantity;
      });

      let changed = false;
      if (Object.keys(updates).length) {
        cart = await cartPost('cart/update.js', { updates });
        changed = true;
      }

      const details = buildDetails(cart);
      const current = (cart.attributes || {})[SETTINGS.detailsAttribute] || '';
      if (details !== current) {
        cart = await cartPost('cart/update.js', { attributes: { [SETTINGS.detailsAttribute]: details } });
      }

      if (changed) {
        if (isCartPage()) { location.reload(); return; }
        await syncTheme();
      }
    } catch (_) { /* silent */ }
    finally {
      running = false;
      if (again) { again = false; scheduleReconcile(); }
    }
  }

  const CART_WRITE = /\/cart\/(add|change|update|clear)/;
  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (CART_WRITE.test(url)) p.then(scheduleReconcile, () => {});
    return p;
  };
  const xOpen = XMLHttpRequest.prototype.open;
  const xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._nvUrl = url;
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_WRITE.test(String(this._nvUrl || ''))) this.addEventListener('load', scheduleReconcile);
    return xSend.apply(this, arguments);
  };

  reconcile();
  window.addEventListener('pageshow', e => { if (e.persisted) reconcile(); });

  /* ---------- Copy the original button's look onto our proxy ---------- */
  const LOOK_PROPS = [
    'display', 'width', 'min-width', 'max-width', 'height', 'min-height',
    'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
    'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
    'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style',
    'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
    'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius',
    'background-color', 'background-image', 'color', 'font-family', 'font-size', 'font-weight',
    'letter-spacing', 'text-transform', 'line-height', 'text-align', 'box-shadow',
    'justify-content', 'align-items', 'flex', 'flex-basis', 'flex-grow'
  ];
  function copyLook(src, dst) {
    const cs = getComputedStyle(src);
    LOOK_PROPS.forEach(p => {
      const v = cs.getPropertyValue(p);
      if (v) dst.style.setProperty(p, v);
    });
    if (cs.display === 'none') dst.style.setProperty('display', 'block');
  }

  /* ---------- Component ---------- */
  class NvAddons extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      try { this.cfg = JSON.parse(this.querySelector('[data-nv-config]').textContent); } catch (_) { return; }
      this._ready = true;
      this.items = Array.from(this.querySelectorAll('[data-nv-addon]'));
      this.items.forEach(i => {
        i._priceHTML = i.querySelector('[data-nv-price]').innerHTML;
        i._price0 = i.dataset.price;
      });
      this.msg = this.querySelector('[data-nv-msg]');

      this.addEventListener('change', e => this.onChange(e));
      this.addEventListener('click', e => this.onStep(e));

      const refresh = () => setTimeout(() => this.renderSummary(), 40);
      document.addEventListener('variant:change', refresh);
      document.addEventListener('change', e => { if (!this.contains(e.target)) refresh(); });
      document.addEventListener('input', e => { if (e.target && e.target.name === 'quantity') refresh(); });

      this.injectHideRule();

      // Proxy button: build after the theme finishes rendering, rebuild if the theme re-renders its buttons
      if (SETTINGS.proxyButton) {
        setTimeout(() => this.ensureProxy(), 300);
        const scope = this.section() || document.body;
        let t;
        new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => this.ensureProxy(), 120); })
          .observe(scope, { childList: true, subtree: true });
      }
      this.renderSummary();
    }

    section() { return this.closest('[id^="shopify-section-"]'); }
    forLabel(id) {
      const v = this.cfg.variants[id] || {};
      let s = this.cfg.title;
      if (v.title && v.title !== 'Default Title') s += ` – ${v.title}`;
      if (v.sku) s += ` (${v.sku})`;
      return s;
    }
    owns(form) {
      if (!form) return false;
      const id = new FormData(form).get('id');
      return !!(id && this.cfg.variants[id]);
    }
    findForm() {
      const section = this.section();
      const local = section && Array.from(section.querySelectorAll('form[action*="/cart/add"]')).find(f => this.owns(f));
      return local || Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(f => this.owns(f));
    }
    selected() {
      return this.items.filter(i => i.querySelector('[data-nv-check]').checked).map(i => ({
        el: i,
        variantId: Number(i.dataset.variantSel || i.dataset.variantId),
        price: Number(i.dataset.price),
        mode: i.dataset.mode,
        qty: Number(i.dataset.qty) || 1
      }));
    }
    hasSelection() { return this.items.some(i => i.querySelector('[data-nv-check]').checked); }

    /* find the theme's real Add to cart button */
    findAtc() {
      const usable = b => b && !b.closest('nv-addons') && !b.classList.contains('nv-atc')
        && !b.matches(SETTINGS.buyNowSelector) && !b.closest(SETTINGS.buyNowSelector);
      const scope = this.section() || document;
      const form = this.findForm();
      let btn = form && Array.from(form.querySelectorAll(SETTINGS.addToCartSelector)).find(usable);
      if (!btn) btn = Array.from(scope.querySelectorAll(SETTINGS.addToCartSelector)).find(usable);
      if (!btn) btn = Array.from(scope.querySelectorAll('button, [role="button"], input[type="submit"]'))
        .find(b => usable(b) && /add to (cart|bag)/i.test(b.textContent || b.value || ''));
      return btn || null;
    }

    /* swap: theme button ⇄ our button */
    ensureProxy() {
      if (!SETTINGS.proxyButton) return;
      const atc = (this._atc && this._atc.isConnected) ? this._atc : this.findAtc();
      if (!atc) return;
      if (this._atc !== atc || !this._proxy || !this._proxy.isConnected) {
        if (this._proxy) this._proxy.remove();
        if (this._atc) this._atc.classList.remove('nv-atc-hidden');
        atc.classList.remove('nv-atc-hidden');
        const p = document.createElement('button');
        p.type = 'button';
        p.className = 'nv-atc';
        p.textContent = (atc.textContent || atc.value || 'Add to cart').replace(/\s+/g, ' ').trim() || 'Add to cart';
        copyLook(atc, p);
        p.hidden = true;
        p.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          if (!this.validate()) return;
          const f = this.findForm();
          if (f) this.run(f, p, false);
        });
        atc.insertAdjacentElement('afterend', p);
        this._atc = atc;
        this._proxy = p;
      }
      const on = this.hasSelection();
      this._atc.classList.toggle('nv-atc-hidden', on);
      this._proxy.hidden = !on;
    }

    injectHideRule() {
      if (SETTINGS.buyNowMode !== 'hide') return;
      const section = this.section();
      const scope = section ? `#${CSS.escape(section.id)}` : 'body';
      const sel = SETTINGS.buyNowSelector.split(',').map(s => `body.nv-has-addons ${scope} ${s.trim()}`).join(',');
      const style = document.createElement('style');
      style.textContent = `${sel}{display:none!important}`;
      document.head.appendChild(style);
    }

    resolveVariant(item) {
      const json = item.querySelector('[data-nv-variants-json]');
      if (!json) return;
      if (!item._variants) item._variants = JSON.parse(json.textContent);
      const picked = Array.from(item.querySelectorAll('[data-nv-option]')).map(g => {
        const r = g.querySelector('input:checked');
        return r ? r.value : null;
      });
      delete item.dataset.variantSel;
      if (picked.some(v => v === null)) return;
      const match = item._variants.find(v => v.options.every((o, idx) => o === picked[idx]));
      if (!match || !match.available) { this.showItemError(item, 'This combination is not available'); return; }
      item.dataset.variantSel = match.id;
      item.dataset.price = match.price;
      item.querySelector('[data-nv-price]').textContent = formatMoney(match.price, this.cfg.moneyFormat);
      this.clearItemError(item);
    }

    onChange(e) {
      const item = e.target.closest('[data-nv-addon]');
      if (!item) return;
      if (e.target.matches('[data-nv-check]')) {
        const on = e.target.checked;
        item.classList.toggle('is-selected', on);
        item.querySelectorAll('[data-nv-variants],[data-nv-stepper]').forEach(p => { p.hidden = !on; });
        if (!on) this.clearItemError(item);
      } else if (e.target.type === 'radio') {
        this.resolveVariant(item);
      }
      this.showMsg('');
      this.renderSummary();
    }
    onStep(e) {
      const btn = e.target.closest('[data-nv-step]');
      if (!btn) return;
      const item = btn.closest('[data-nv-addon]');
      const max = Number(item.dataset.max) || 10;
      const q = Math.min(max, Math.max(1, (Number(item.dataset.qty) || 1) + Number(btn.dataset.nvStep)));
      item.dataset.qty = q;
      item.querySelector('[data-nv-qty]').textContent = q;
      this.renderSummary();
    }
    validate() {
      const bad = this.selected().filter(a => !a.variantId);
      bad.forEach(a => this.showItemError(a.el));
      if (bad.length) { bad[0].el.scrollIntoView({ behavior: 'smooth', block: 'center' }); return false; }
      return true;
    }
    showItemError(item, text) {
      const err = item.querySelector('[data-nv-error]');
      if (err) {
        if (!err._default) err._default = err.textContent;
        err.textContent = text || err._default;
        err.hidden = false;
      }
      item.classList.remove('is-error'); void item.offsetWidth; item.classList.add('is-error');
    }
    clearItemError(item) {
      item.classList.remove('is-error');
      const err = item.querySelector('[data-nv-error]');
      if (err) err.hidden = true;
    }
    showMsg(text) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.hidden = !text;
    }
    renderSummary() {
      const sel = this.selected();
      document.body.classList.toggle('nv-has-addons', sel.length > 0);
      this.ensureProxy();
      const box = this.querySelector('[data-nv-summary]');
      if (!box) return;
      if (!sel.length) { box.hidden = true; return; }
      const form = this.findForm();
      const fd = form ? new FormData(form) : null;
      const v = fd && this.cfg.variants[fd.get('id')];
      const qty = Math.max(1, parseInt(fd && fd.get('quantity'), 10) || 1);
      const base = v ? v.price * qty : 0;
      const extras = sel.reduce((s, a) => s + (a.price || 0) * (a.mode === 'free' ? a.qty : qty), 0);
      const f = c => formatMoney(c, this.cfg.moneyFormat);
      box.querySelector('[data-nv-summary-line]').textContent =
        `${SETTINGS.summaryLabel} ${f(base)} + ${sel.length} add-on${sel.length > 1 ? 's' : ''} ${f(extras)}`;
      box.querySelector('[data-nv-summary-total]').textContent = `Total ${f(base + extras)}`;
      box.hidden = false;
    }
    reset() {
      this.items.forEach(i => {
        i.querySelector('[data-nv-check]').checked = false;
        i.classList.remove('is-selected', 'is-error');
        i.querySelectorAll('[data-nv-variants],[data-nv-stepper],[data-nv-error]').forEach(p => { p.hidden = true; });
        i.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
        delete i.dataset.variantSel;
        i.dataset.price = i._price0;
        i.dataset.qty = 1;
        const q = i.querySelector('[data-nv-qty]'); if (q) q.textContent = 1;
        i.querySelector('[data-nv-price]').innerHTML = i._priceHTML;
      });
      this.renderSummary();
    }

    async run(form, btn, viaBuyNow) {
      if (this._busy) return;
      this._busy = true;
      this.showMsg('');
      const isProxy = btn && btn.classList && btn.classList.contains('nv-atc');
      const label = isProxy ? btn.textContent : null;
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      if (isProxy) btn.textContent = 'Adding…';
      try {
        await addBundle(this, form);
        await reconcile();
        if (isProxy) btn.textContent = label;
        this.reset();
        if (viaBuyNow && SETTINGS.buyNowMode === 'checkout') { window.location.href = ROOT + 'checkout'; return; }
        await syncTheme({ open: true });
      } catch (err) {
        this.showMsg(err.message || 'Something went wrong. Please try again.');
      } finally {
        this._busy = false;
        if (isProxy) btn.textContent = label;
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      }
    }
  }

  /* ---------- Global interceptors (backup for themes without Shiprocket hijack) ---------- */
  const instances = () => Array.from(document.querySelectorAll('nv-addons')).filter(c => c.cfg);
  const stop = e => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };

  window.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest(SETTINGS.addToCartSelector);
    if (!btn || btn.closest('nv-addons') || btn.closest(DRAWER_SCOPE) || btn.classList.contains('nv-atc')) return;
    if (btn.matches(SETTINGS.buyNowSelector) || btn.closest(SETTINGS.buyNowSelector)) return;
    const form = btn.form || btn.closest('form');
    const comp = instances().find(c => c.hasSelection() && (
      c.owns(form) || (!form && c.section() && c.section().contains(btn))
    ));
    if (!comp) return;
    stop(e);
    if (!comp.validate()) return;
    const target = comp.owns(form) ? form : comp.findForm();
    if (target) comp.run(target, btn, false);
  }, true);

  window.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const comp = instances().find(c => c.owns(form) && c.hasSelection());
    if (!comp) return;
    stop(e);
    if (!comp.validate()) return;
    comp.run(form, e.submitter || form.querySelector('[type="submit"]'), false);
  }, true);

  // Buy Now — ONLY the one on the product page, never the one inside the cart/bag
  window.addEventListener('click', e => {
    if (SETTINGS.buyNowMode === 'hide') return;
    const bn = e.target.closest && e.target.closest(SETTINGS.buyNowSelector);
    if (!bn) return;
    const comp = instances().find(c => c.hasSelection() && c.section() && c.section().contains(bn));
    if (!comp || comp.contains(bn) || bn.closest(DRAWER_SCOPE)) return;
    stop(e);
    if (!comp.validate()) return;
    const form = comp.findForm();
    if (form) comp.run(form, null, true);
  }, true);

  customElements.define('nv-addons', NvAddons);
})();